
import React, { useState } from 'react';

const LanguageSelectorModal = ({ show, onClose, languageList, onConfirm }) => {
    const [selectedLanguage, setSelectedLanguage] = useState('');

    const handleConfirm = () => {
        if (selectedLanguage) {
            onConfirm(selectedLanguage);
            onClose(); 
        }
    };

    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog-centered justify-content-center">
                <div className="p-4 bg-white border-radius-20">

                    <div className='card language-popup d-flex flex-column justify-content-center align-items-center text-center border-0 mb-4'>
                        <a onClick={onClose} className='w-100 text-end test-decoration-none'><svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                            <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                        </svg>
                        </a>

                        <h3 className='fw-bold font-26 my-4'>Select Language</h3>
                        <p className='mb-4'>Please choose your preferred language from the dropdown menu for the course. Once selected, it cannot be changed later on.</p>
                        <div className='w-75 mb-3 m-auto'>
                            <select
                                className="form-select position-relative w-100 h-40 fw-bold"
                                value={selectedLanguage}
                                onChange={(e) => setSelectedLanguage(e.target.value)}
                            >
                                <option value="">-- Select Language --</option>
                                {languageList.map((lang, index) => (
                                    <option key={index} value={lang.id}>{lang.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className='d-flex justify-content-center align-items-center w-100 mt-3'>
                            <button className='btn btn-md px-5 btn-primary' disabled={!selectedLanguage} onClick={handleConfirm}>Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

};

export default LanguageSelectorModal;
